var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "more-detail",
      class: _vm.sticky_element_class,
      staticStyle: { overflow: "hidden" }
    },
    [
      _vm.r_btn_type == 0 ? _c("div", { staticClass: "layout-btn" }) : _vm._e(),
      _vm._v(" "),
      _vm.r_btn_type == 1
        ? _c("div", { staticClass: "layout-btn" }, [
            _vm.r_is_disp_confirm_btn
              ? _c(
                  "button",
                  {
                    staticClass: "btn-ok",
                    attrs: { disabled: !_vm.r_is_confirm_enable },
                    on: { click: _vm.onBtnOK }
                  },
                  [_c("i", { staticClass: "fa-solid fa-check" })]
                )
              : _c("div", { staticClass: "btn-space" }),
            _vm._v(" "),
            _vm.r_is_disp_delete_btn
              ? _c(
                  "button",
                  {
                    staticClass: "btn-delete",
                    attrs: { disabled: !_vm.r_is_delete_enable },
                    on: {
                      click: function($event) {
                        return _vm.onBtnDelete(_vm.r_messages.delete_check_text)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-trash" })]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "right" }, [
              _c(
                "button",
                {
                  staticClass: "btn-restore",
                  attrs: { disabled: !_vm.r_is_restore_enable },
                  on: { click: _vm.onBtnRestore }
                },
                [_c("i", { staticClass: "fa-solid fa-rotate" })]
              )
            ])
          ])
        : (_vm.r_btn_type == 2 || _vm.r_btn_type == 3) && _vm.r_check_edit
        ? _c("div", { staticClass: "layout-btn" }, [
            _vm.r_btn_type == 2
              ? _c("span", [
                  _vm.r_is_disp_confirm_btn
                    ? _c(
                        "button",
                        {
                          staticClass: "btn-ok",
                          attrs: { disabled: !_vm.r_is_confirm_enable },
                          on: { click: _vm.onBtnOK }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.r_messages.registration_apply_btn) +
                              " "
                          )
                        ]
                      )
                    : _c("div", { staticClass: "btn-space" }),
                  _vm._v(" "),
                  _vm.r_is_disp_delete_btn
                    ? _c(
                        "button",
                        {
                          staticClass: "btn-delete",
                          attrs: { disabled: !_vm.r_is_delete_enable },
                          on: {
                            click: function($event) {
                              return _vm.onBtnDelete(
                                _vm.r_messages.delete_check_text
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.r_messages.delete_apply_btn) + " "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.r_is_disp_new_btn
                    ? _c(
                        "button",
                        {
                          staticClass: "btn-ok",
                          on: { click: _vm.onBtnNewData }
                        },
                        [
                          _vm._v(
                            "\r\n\t\t\t\t\t\t" +
                              _vm._s(_vm.r_messages.new_date_btn)
                          )
                        ]
                      )
                    : _vm._e()
                ])
              : _c("span", [
                  _c(
                    "button",
                    {
                      staticClass: "btn-ok",
                      attrs: { disabled: !_vm.r_is_confirm_enable },
                      on: { click: _vm.onBtnOK }
                    },
                    [_vm._v(" " + _vm._s(_vm.r_messages.apply_btn) + " ")]
                  ),
                  _vm._v(" "),
                  _vm.r_is_apply == true
                    ? _c("span", [
                        _c(
                          "button",
                          {
                            staticClass: "btn-delete",
                            attrs: { disabled: !_vm.r_is_delete_enable },
                            on: {
                              click: function($event) {
                                return _vm.onBtnDelete(
                                  _vm.r_messages.msg_app_discharge_check_text
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.r_messages.apply_stop_btn) + " "
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.r_is_apply == false
                    ? _c("span", [
                        _c(
                          "button",
                          {
                            staticClass: "btn-delete",
                            attrs: { disabled: !_vm.r_is_delete_enable },
                            on: {
                              click: function($event) {
                                return _vm.onBtnDelete(
                                  _vm.r_messages.msg_res_discharge_check_text
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.r_messages.apply_stop_btn) + " "
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.r_is_disp_new_btn
                    ? _c(
                        "button",
                        {
                          staticClass: "btn-ok",
                          on: { click: _vm.onBtnNewData }
                        },
                        [
                          _vm._v(
                            "\r\n\t\t\t\t\t\t" +
                              _vm._s(_vm.r_messages.new_date_btn)
                          )
                        ]
                      )
                    : _vm._e()
                ]),
            _vm._v(" "),
            _c("div", { staticClass: "right" }, [
              _vm.r_is_disp_edit_btn
                ? _c(
                    "button",
                    { staticClass: "btn-ok", on: { click: _vm.onBtnEditData } },
                    [_vm._v(" " + _vm._s(_vm.r_messages.edit))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-restore",
                  attrs: { disabled: !_vm.r_is_restore_enable },
                  on: { click: _vm.onBtnRestore }
                },
                [
                  _c("i", { staticClass: "fa-solid fa-rotate" }),
                  _vm._v("   " + _vm._s(_vm.r_messages.restore_btn))
                ]
              )
            ])
          ])
        : _vm.r_btn_type == 4 && _vm.r_check_edit
        ? _c("div", { staticClass: "layout-btn" }, [
            _vm.r_approval_btn_disp
              ? _c(
                  "button",
                  {
                    staticClass: "btn-ok",
                    attrs: { disabled: !_vm.r_is_confirm_enable },
                    on: { click: _vm.onBtnOK }
                  },
                  [_vm._v(" " + _vm._s(_vm.r_messages.approval_btn) + " ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.r_denial_btn_disp
              ? _c(
                  "button",
                  {
                    staticClass: "btn-delete",
                    attrs: { disabled: !_vm.r_is_delete_enable },
                    on: { click: _vm.onBtnDelete }
                  },
                  [_vm._v(" " + _vm._s(_vm.r_messages.denial_btn) + " ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.r_send_btn_disp
              ? _c(
                  "button",
                  {
                    staticClass: "btn-restore",
                    attrs: { disabled: !_vm.r_is_restore_enable },
                    on: { click: _vm.onBtnRestore }
                  },
                  [_vm._v(" " + _vm._s(_vm.r_messages.send_back_btn))]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "right" }, [
              _vm.r_is_disp_edit_btn
                ? _c(
                    "button",
                    { staticClass: "btn-ok", on: { click: _vm.onBtnEditData } },
                    [_vm._v(" " + _vm._s(_vm.r_messages.edit))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.r_restore_btn_disp
                ? _c(
                    "button",
                    {
                      staticClass: "btn-restore",
                      attrs: { disabled: !_vm.r_is_restore_enable },
                      on: { click: _vm.onBtnReload }
                    },
                    [
                      _c("i", { staticClass: "fa-solid fa-rotate" }),
                      _vm._v("   " + _vm._s(_vm.r_messages.restore_btn))
                    ]
                  )
                : _vm._e()
            ])
          ])
        : _vm.r_btn_type == 5
        ? _c("div", { staticClass: "layout-btn" }, [
            _vm.r_is_disp_confirm_btn
              ? _c(
                  "button",
                  {
                    staticClass: "btn-ok",
                    attrs: { disabled: !_vm.r_is_confirm_enable },
                    on: {
                      click: function($event) {
                        return _vm.onBtnDelete(_vm.r_messages.delete_check_text)
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.r_messages.confirm_btn) + " ")]
                )
              : _c("div", { staticClass: "btn-space" }),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "btn-delete", on: { click: _vm.onBtnOK } },
              [_vm._v(" " + _vm._s(_vm.r_messages.delete_cancel_btn) + " ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "right" }, [
              _c(
                "button",
                {
                  staticClass: "btn-restore",
                  attrs: { disabled: !_vm.r_is_restore_enable },
                  on: { click: _vm.onBtnRestore }
                },
                [
                  _c("i", { staticClass: "fa-solid fa-rotate" }),
                  _vm._v("   " + _vm._s(_vm.r_messages.restore_btn))
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "btn-space" })
            ])
          ])
        : _vm.r_btn_type == 6
        ? _c("div", { staticClass: "layout-btn" }, [
            _c(
              "button",
              {
                staticClass: "btn-ok",
                attrs: { disabled: !_vm.r_is_confirm_enable },
                on: { click: _vm.onBtnOK }
              },
              [_vm._v(" " + _vm._s(_vm.r_messages.registration_btn) + " ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "right" }, [
              _c(
                "button",
                {
                  staticClass: "btn-restore",
                  attrs: { disabled: !_vm.r_is_restore_enable },
                  on: { click: _vm.onBtnRestore }
                },
                [
                  _c("i", { staticClass: "fa-solid fa-rotate" }),
                  _vm._v("   " + _vm._s(_vm.r_messages.restore_btn))
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.r_btn_type == 7
        ? _c("div", { staticClass: "layout-btn" }, [
            _vm.r_is_disp_confirm_btn
              ? _c(
                  "button",
                  {
                    staticClass: "btn-ok",
                    attrs: { disabled: !_vm.r_is_confirm_enable },
                    on: { click: _vm.onBtnOK }
                  },
                  [_c("i", { staticClass: "fa-solid fa-check" })]
                )
              : _c("div", { staticClass: "btn-space" }),
            _vm._v(" "),
            _vm.r_is_disp_copy_btn
              ? _c(
                  "button",
                  {
                    staticClass: "btn-copy",
                    attrs: { disabled: !_vm.r_is_copy_enable },
                    on: { click: _vm.onBtnCopyNew }
                  },
                  [_c("i", { staticClass: "fa-regular fa-copy" })]
                )
              : _c("div", { staticClass: "btn-space" }),
            _vm._v(" "),
            _vm.r_is_disp_delete_btn
              ? _c(
                  "button",
                  {
                    staticClass: "btn-delete",
                    attrs: { disabled: !_vm.r_is_delete_enable },
                    on: {
                      click: function($event) {
                        return _vm.onBtnDelete(_vm.r_messages.delete_check_text)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-trash" })]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "right" }, [
              _c(
                "button",
                {
                  staticClass: "btn-restore",
                  attrs: { disabled: !_vm.r_is_restore_enable },
                  on: { click: _vm.onBtnRestore }
                },
                [_c("i", { staticClass: "fa-solid fa-rotate" })]
              )
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-351e1350", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-351e1350","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/parts_com/btnsWndDetail.vue
// module id = 595
// module chunks = 0 1 2